<template>
  <div class="account">
    <el-row  :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" v-for="item in bankAccounts" :key="item.Id">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ item.currency }} Account</span>
          </div>
          <div>
            <el-form :model="bankAccountForm[item.currency]" :rules="rules[item.currency]" :ref="'bankAccountForm' + item.currency" label-width="120px">
              <el-form-item label="Account Name" prop="accountname">
                <el-input v-model="bankAccountForm[item.currency].accountname" :readonly="readonly[item.currency]"></el-input>
              </el-form-item>
              <el-form-item label="Bank Name" prop="bankname">
                <el-input v-model="bankAccountForm[item.currency].bankname" :readonly="readonly[item.currency]"></el-input>
              </el-form-item>
              <el-form-item :label="item.currency === 'GBP' ? 'Account Number' : 'IBAN'" prop="iban">
                <el-input v-model="bankAccountForm[item.currency].iban" :readonly="readonly[item.currency]"></el-input>
              </el-form-item>
              <el-form-item :label="item.currency === 'GBP' ? 'Sort Code' : 'BICS'" prop="bic">
                <el-input v-model="bankAccountForm[item.currency].bic" :readonly="readonly[item.currency]"></el-input>
              </el-form-item>
              <el-form-item label="Status" prop="status">
                <el-tag v-if="item.status && item.status === '1'" type="success">Active</el-tag>
                <el-tag v-if="!item.status" type="danger">Disable</el-tag>
              </el-form-item>

              <el-form-item v-if="readonly[item.currency]">
                <el-button type="primary" @click="requestChange(item.currency)">Request Change {{ item.currency }} Account</el-button>
              </el-form-item>

              <el-form-item v-if="!readonly[item.currency]">
                <el-button type="success"   :loading="btnLoading[item.currency]" @click="submitUpdate(item.currency, 'bankAccountForm'+item.currency)">Submit</el-button>
                <el-button @click="requestCancel()">Cancel</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import account from '@/api/account'
export default {
  data() {
    return {
      bankAccounts: [],
      btnLoading: {
        "GBP" : false,
        "EUR" : false
      },
      readonly: {
        "GBP" : true,
        "EUR" : true
      },
      bankAccountForm:{
        "GBP": {
            "bankname": String, 
            "currency": String, 
            "accountname": String,
            "iban": String,
            "bic": String
        },
        "EUR": {
            "bankname": String, 
            "currency": String, 
            "accountname": String,
            "iban": String,
            "bic": String
        }
      },
      rules:{
        "GBP" : {
          "bankname": [{ required: true, message: "Please enter Bank name", trigger: "blur" }], 
          "accountname": [{ required: true, message: "Please enter Account name", trigger: "blur" }],
          "iban": [{ required: true, message: "Please enter Account number", trigger: "blur" }],
          "bic": [{ required: true, message: "Please enter Sort code", trigger: "blur" }]
        },
        "EUR" : {
          "bankname": [{ required: true, message: "Please enter Bank name", trigger: "blur" }], 
          "accountname": [{ required: true, message: "Please enter Account name", trigger: "blur" }],
          "iban": [{ required: true, message: "Please enter IBAN", trigger: "blur" }],
          "bic": [{ required: true, message: "Please enter BICS", trigger: "blur" }]
        }
      }
    }
  },
  methods:{
    getBankAccount(){
      account.getBankAccount().then( res =>{
         if (res && res["result"]) {
          this.bankAccounts = res["data"];
          this.bankAccounts.forEach(element => {
            if(this.bankAccountForm[element.currency]){
              this.bankAccountForm[element.currency].bankname = element.bankname
              this.bankAccountForm[element.currency].currency = element.currency
              this.bankAccountForm[element.currency].accountname = element.accountname
              this.bankAccountForm[element.currency].iban = element.iban
              this.bankAccountForm[element.currency].bic = element.bic
            }
          });
        }
      })
    },
    requestChange(currency){
      this.requestCancel()
      this.readonly[currency] = false
    },
    requestCancel(){
      this.$refs['bankAccountFormGBP'][0].resetFields();
      this.$refs['bankAccountFormEUR'][0].resetFields();
      this.getBankAccount()
      this.readonly.GBP = true
      this.readonly.EUR = true
    },
    submitUpdate(currency, form){
      this.btnLoading[currency] = true;
       this.$refs[form][0].validate(valid => {
         if(valid){
           account.requestUpdate(this.bankAccountForm[currency]).then(res=>{
             if (res && res["result"]) {
               this.btnLoading[currency] = false;
               this.$alert('Your bank account update will be applied to the system after the operation team approved.', 'Thank you for request update.', {
                confirmButtonText: 'OK',
                callback: () => {
                  this.requestCancel()
                }
              });
             }
           })
         }else{
           this.btnLoading[currency] = false;
         }
       });
    }
  },
  created(){
    this.getBankAccount()
  }
}
</script>

<style lang="scss">
.account{
  $bgColor: #eaeaea;
  input:-moz-read-only { /* For Firefox */
    background-color: $bgColor;
  }

  input:read-only {
    background-color: $bgColor;
  }
}
</style>